var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report__page"},[_c('h2',[_vm._v("Report Details")]),_c('ReportDetailsSelector',{attrs:{"details":_vm.customDetails,"is-compact":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }